import fetchJson from "../lib/react-admin-loopback/fetch";
import { stringify } from "query-string";
import { cloneDeep } from "lodash-es";
import {
  getYearMonth,
  addDashToDateString,
  getYearMonthDate3,
  weekDays,
} from "../calendar";
import { sortMenus } from "./functions";
import { weekdays } from "moment";

export async function reqSchedules(dataProvider, customerId, firstDate) {
  return await dataProvider.getList("schedules", {
    pagination: { page: 1 },
    sort: { field: "date", order: "ASC" },
    queryParams: {
      yearMonth: getYearMonth(firstDate),
      customerId: customerId,
    },
  });
}

export async function reqSuggestion(
  customerId,
  firstDateOfMonth,
  meals,
  menuRatio
) {
  // build order data
  const orders = buildSchedules(meals);

  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/schedules/curationByCustomer`;
  const options = {
    method: "POST",
    body: JSON.stringify({
      yearMonth: getYearMonth(firstDateOfMonth),
      customerId: customerId,
      menuRatio,
      orders,
    }),
  };
  const { json } = await fetchJson(url, options);
  return {
    data: json,
  };
}

export async function reqSuppliers(keyword, page = 1, perPage = 30) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      where: {
        and: [
          {
            name: {
              like: `%${keyword}%`,
              options: "i",
            },
          },
          {
            curation: true,
          },
        ],
      },
      limit: perPage,
      skip: (page - 1) * perPage,
      order: "name ASC",
    }),
    clientType: "bo",
  };
  const url = `${apiUrl}/suppliers?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);
  return {
    data: json,
    total: parseInt(headers.get("content-range").split("/").pop(), 10),
  };
}

export async function reqMenus(supplierId = -1, page = 1, perPage = 30) {
  const apiUrl = process.env.REACT_APP_API_URL;

  const filter = {
    limit: perPage,
    skip: (page - 1) * perPage,
    order: "supplierId ASC",
  };

  if (supplierId >= 0) {
    filter.where = {
      supplierId,
    };
  }

  const params = {
    filter: JSON.stringify(filter),
    clientType: "bo",
  };

  const url = `${apiUrl}/menus/all?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);
  return {
    data: json,
    total: parseInt(headers.get("content-range").split("/").pop(), 10),
  };
}

export async function reqCuratedMenus(page = 1, perPage = 30, customerId) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      limit: perPage,
      skip: (page - 1) * perPage,
      order: "supplierId ASC",
    }),
    clientType: "bo",
  };
  const url = `${apiUrl}/menus/customers/${customerId}?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);
  return {
    data: json,
    total: parseInt(headers.get("content-range").split("/").pop(), 10),
  };
}

export async function reqPbMenus() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      litmit: 30,
      skip: 0,
      order: "name ASC",
    }),
    clientType: "bo",
  };
  const url = `${apiUrl}/menus/pb?${stringify(params)}`;
  const { json } = await fetchJson(url);
  return {
    data: json,
  };
}

export async function reqSearchMenus(page = 1, perPage = 30, search = "") {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      limit: perPage,
      skip: (page - 1) * perPage,
      search: search,
      order: "supplierId ASC",
    }),
    clientType: "bo",
  };
  const url = `${apiUrl}/customers/menuForFilter?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);
  return {
    data: json,
    total: parseInt(headers.get("content-range").split("/").pop(), 10),
  };
}

export async function reqGetFilteredMenu(customerId) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      // limit: 200,
      // skip: 0,
      order: "supplierId ASC",
    }),
    clientType: "bo",
  };
  const url = `${apiUrl}/customers/${customerId}/filteredMenu?${stringify(
    params
  )}`;
  const { json } = await fetchJson(url);
  return {
    data: json,
  };
}

export async function reqPostFilteredMenu(customerId, menus) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/customers/${customerId}/filteredMenu`;
  const options = {
    method: "POST",
    body: JSON.stringify(menus),
  };
  const { json } = await fetchJson(url, options);
  return {
    data: json,
  };
}

export async function reqCustomer(customerId) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    clientType: "bo",
  };
  const url = `${apiUrl}/customers/${customerId}?${stringify(params)}`;
  const { json } = await fetchJson(url);
  return {
    data: json,
  };
}

export async function reqCustomers(page = 1, perPage = 30) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      limit: perPage,
      skip: (page - 1) * perPage,
      order: "name ASC",
    }),
    // clientType: 'bo'
  };
  const url = `${apiUrl}/customers?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);
  return {
    data: json,
    total: parseInt(headers.get("content-range").split("/").pop(), 10),
  };
}

export async function searchCustomers(word, page = 1, perPage = 30) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      limit: perPage,
      skip: 0,
      order: "name ASC",
      where: { name: `${word}` },
    }),
    clientType: "bo",
  };

  const url = `${apiUrl}/customers?${stringify(params)}`;
  const { headers, json } = await fetchJson(url);

  return {
    data: json,
    total: parseInt(headers.get("content-range").split("/").pop(), 10),
  };
}

export async function reqSubMenus(menuId) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const params = {
    filter: JSON.stringify({
      order: "name ASC",
    }),
  };
  const url = `${apiUrl}/menus/${menuId}/subMenu?${stringify(params)}`;
  const { json } = await fetchJson(url);
  return {
    data: json,
  };
}

export async function reqSaveSchedules(meals) {
  // build body data
  const schedules = buildSchedules(meals, true);

  // request
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/schedules/bulkInsert`;
  const options = {
    method: "POST",
    body: JSON.stringify(schedules),
  };
  const { json } = await fetchJson(url, options);
  return {
    data: json,
  };
}

export async function reqPublish(customerId, dates, publish) {
  // body data
  const body = [
    {
      customerId,
      date: dates.map((day) => getYearMonthDate3(day)),
      publish,
    },
  ];

  // request
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/schedules/publish`;
  const options = {
    method: "POST",
    body: JSON.stringify(body),
  };
  const { json } = await fetchJson(url, options);
  return {
    data: json,
  };
}

function buildSchedules(meals, correctMenuType = false) {
  const schedules = [];

  meals.forEach((meal) => {
    // find a target schedule item
    const dateString = addDashToDateString(meal.date);
    let found = schedules.find((s) => s.date === dateString);
    if (!found) {
      found = {
        date: dateString,
        customerId: meal.customerId,
        customerName: meal.customerName,
        // deliveryGroup: meal.deliveryGroup,
        menu: [],
      };
      schedules.push(found);
    }

    // filter out placeholders
    const menus = meal.menu
      .filter((menu) => menu.menuType === "2" || menu.id || menu.menuId)
      .map((menu) => cloneDeep(menu));

    if (menus.length == 0) {
      return;
    }

    // sort menus
    sortMenus(menus);

    if (correctMenuType) {
      // 기본 메뉴 (menuType: 0) 정돈
      const hasDefaultMenu = menus.some(
        (menu) => menu.menuType === "0" && menu.menuId !== null
      );
      if (!hasDefaultMenu) {
        const newDefaultMenu = menus.find(
          (menu) => menu.menuType !== "2" && menu.menuId !== null
        );
        if (newDefaultMenu) {
          // 기존의 기본 메뉴는 삭제되고 수동으로 메뉴 항목이 추가되었다면
          // 새로 추가된 것을 기본 메뉴로 지정
          const existingDefaultMenu = menus.find(
            (menu) => menu.menuType === "0"
          );
          if (existingDefaultMenu) {
            existingDefaultMenu.menuType = "1";
          }
          newDefaultMenu.menuType = "0";
        }
        // console.log(JSON.stringify(menus))
      }
    }

    // append menus
    found.menu = found.menu.concat(
      menus.map((menu) => ({
        id: menu.id ?? null,
        published: menu.published ?? false,
        lock: menu.lock ?? false,
        date: dateString,
        serviceTime: menu.serviceTime,
        customerId: meal.customerId,
        supplierId: menu.supplierId ?? null,
        menuType: menu.menuType,
        menuId: menu.menu?.id ?? menu.menuId ?? null,
        menuName: menu.menu?.name ?? null,
        menuCategory: menu.menu?.menuCategory ?? [],
        supplierPrice: menu.supplierPrice ? menu.supplierPrice : (
          menu.menu?.price ?? null
        ),
        serviceType: menu.supplier ? menu.supplier.serviceType : [],
        subMenu: menu.subMenu ?? [],
        pickupTime: menu.pickupTime ?? null,
        orderQty: menu.orderQty ?? null,
        memo: menu.memo ?? null,
        servicePlanId: menu.servicePlanId ?? null,
      }))
    );
  }); // end of meals.forEach

  return schedules;
}

export const reqSaveSchedule = async (menu) => {
  const {
    date,
    serviceTime,
    customerId,
    supplierId,
    menuType,
    menuId,
    subMenu,
    orderQty,
    customerPrice,
    menu: menuInfo,
    pickupTime,
    memo,
    supplier,
    serviceFee,
    paymentFee,
    deliveryFee, // ?
    servicePlanId,
  } = menu;

  // validation payload
  if (!customerPrice || !menuInfo) {
    throw "고객사 큐레이션 정보 확인";
  }

  // build a schedule
  const body = {
    date,
    serviceTime,
    customerId,
    supplierId,
    menuType,
    menuId,
    subMenus: subMenu.map((el) => ({ name: el.name })),
    orderQty: orderQty ?? 0,
    manualCheckout: false,
    pickupTime,
    customerPrice,
    supplierStatus: "0",
    supplierPrice: menuInfo.price,
    supplierServiceFee: supplier.serviceFee,
    supplierPaymentFee: supplier.paymentFee,
    supplierDeliveryFee: supplier.deliveryFee,
    memo,
    servicePlanId,
  };

  // request
  const apiUrl = process.env.REACT_APP_FCS_API_URL;
  const url = `${apiUrl}/schedules`;
  const { json } = await fetchJson(url, {
    method: "POST",
    body: JSON.stringify(body),
  });
  return {
    data: json,
  };
};

export const reqCustomerFCS = async (customerId) => {
  const apiUrl = process.env.REACT_APP_FCS_API_URL;
  const url = `${apiUrl}/customers/${customerId}`;
  const { json } = await fetchJson(url);

  return {
    data: json,
  };
};

export const reqCurationCopy = async (curationCopyData) => {
  const { curationGroupId, customerId, dateFrom, dateTo, overWrite } =
    curationCopyData;
  const body = {
    curationGroupId,
    customerId,
    dateFrom,
    dateTo,
    overWrite,
  };

  const apiUrl = process.env.REACT_APP_FCS_API_URL;
  const url = `${apiUrl}/curations/groupcuration`;
  const { json } = await fetchJson(url, {
    method: "POST",
    body: JSON.stringify(body),
  });

  return {
    data: json,
  };
};
